/*
 * Project: bellcloud
 * File: packages/ui/components/common/Typography.tsx
 * Description: 타이포그래피 컴포넌트 (Text, Heading)
 */

import styled from '@emotion/styled';
import type { AppTheme } from '@/theme';

// 텍스트 컴포넌트
type TextColor = 'textPrimary' | 'textSecondary' | 'textEmphasis' | 'textDisabled' | string;

export const Text = styled.p<{
  size?: keyof AppTheme['fontSize'];
  weight?: keyof AppTheme['fontWeight'];
  color?: TextColor;
  align?: 'left' | 'center' | 'right';
  truncate?: boolean;
}>`
  margin: 0;
  font-size: ${props => `${props.theme.fontSize[props.size || 'md']}px`};
  font-weight: ${props => props.theme.fontWeight[props.weight || 'regular']};
  color: ${props => {
    const colorMap: Record<string, string> = {
      textPrimary: props.theme.colors.text.primary,
      textSecondary: props.theme.colors.text.secondary,
      textEmphasis: props.theme.colors.text.emphasis,
      textDisabled: props.theme.colors.text.disabled,
    };

    return colorMap[props.color || ''] || props.color || props.theme.colors.text.primary;
  }};
  text-align: ${props => props.align || 'left'};
  line-height: ${props => props.theme.lineHeight.normal};

  ${props =>
    props.truncate &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

// 헤딩 컴포넌트
export const Heading = styled.h1<{
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  color?: string;
  align?: 'left' | 'center' | 'right';
}>`
  margin: 0;
  font-weight: ${props => props.theme.fontWeight.semibold};
  color: ${props => props.color || props.theme.colors.text.primary};
  text-align: ${props => props.align || 'left'};
  line-height: ${props => props.theme.lineHeight.tight};

  ${props => {
    const level = props.level || 1;
    const levels: Record<1 | 2 | 3 | 4 | 5 | 6, string> = {
      1: 'font-size: 2.25rem;',
      2: 'font-size: 1.875rem;',
      3: 'font-size: 1.5rem;',
      4: 'font-size: 1.25rem;',
      5: 'font-size: 1.125rem;',
      6: 'font-size: 1rem;',
    };
    return levels[level];
  }}
`;
